export default __webpack_public_path__ + "static/media/transgo-inabit.c9c6d40f.svg";